/**
 * L'anteprima che segue il dito o il mouse mentre si trascina un widget:
 * leggera, solo icona, titolo e taglia, perche' ridisegnare il widget vero a
 * ogni movimento sarebbe pesante e inutile.
 */

import type { WidgetIstanza } from '../../lib/dashboard/layout';
import { ETICHETTE_TAGLIA } from './taglie';
import { titoloWidget } from './titolo';
import { ICONE_WIDGET } from './widget/registro';

export function SegnapostoWidget({ widget }: { widget: WidgetIstanza }) {
  const Icona = ICONE_WIDGET[widget.tipo];
  return (
    <div className="pointer-events-none flex w-56 rotate-1 items-center gap-2 rounded-xl border border-primary-300 bg-white px-3 py-2.5 shadow-2xl">
      <Icona className="h-4 w-4 text-primary-500" />
      <span className="min-w-0 flex-1 truncate text-sm font-semibold text-gray-900">{titoloWidget(widget)}</span>
      <span className="text-[10px] text-neutral-400">{ETICHETTE_TAGLIA[widget.taglia]}</span>
    </div>
  );
}
